import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { useAuthStore } from '@/entities/user';
import { trpc } from '@/shared/api';

interface UseSignOutResult {
  readonly signOut: () => Promise<void>;
}

/**
 * 로그아웃 — 서버 호출이 실패해도 클라이언트 세션은 반드시 정리하고 로그인으로 보낸다.
 * 쿼리 캐시도 비운다 — 회원별 조회(내 견적 등)는 키에 회원이 없어, 같은 탭의 다음 회원에게 이전 회원의 데이터가 보일 수 있다.
 */
export const useSignOut = (): UseSignOutResult => {
  const navigate = useNavigate();
  const clear = useAuthStore((state) => state.clear);
  const queryClient = useQueryClient();
  const mutation = trpc.auth.signOut.useMutation();

  const signOut = async (): Promise<void> => {
    try {
      await mutation.mutateAsync();
    } catch {
      // 서버 로그아웃 실패는 무시한다 — 목적은 클라이언트 세션 정리이고,
      // 서버 리프레시 토큰은 만료로 소멸한다. (미처리 rejection 도 남기지 않는다)
    } finally {
      clear();
      queryClient.clear();
      void navigate('/sign-in');
    }
  };

  return { signOut };
};
